import { render, staticRenderFns } from "./vitamine.vue?vue&type=template&id=cec652a2&scoped=true&"
import script from "./vitamine.vue?vue&type=script&lang=js&"
export * from "./vitamine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec652a2",
  null
  
)

export default component.exports